/**
 * Base filter to remove non valid values
 * @param data
 * @returns {boolean}
 */
export const baseFilter = (data: any): any => !!data;
